import jwtParser from "./jwt-parser";

export default jwt => {
  if(! jwt ){
    return undefined;
  }
  const object = jwtParser(jwt);
  if( ! object ){
    return null;
  }
  return object.sub;
};
